module.exports = __webpack_public_path__ + "static/ColumbiaPictures-1879b3ef52619b5b1da59b3bfd791f59.png";